import React from 'react';

const WA_DEFAULT = 'https://wa.me/971585338786?text=Hi%20I%20am%20interested%20in%20buying%20or%20selling%20an%20e-bike';

export default function Contact() {
  return (
    <div className="fade-in" style={{ maxWidth: 700, margin: '0 auto', padding: '48px 20px' }}>
      <h1 style={{ fontSize: 32, marginBottom: 16 }}>Contact Us</h1>
      <p style={{ color: 'var(--text-2)', marginBottom: 32 }}>The fastest way to reach us is WhatsApp. We typically respond within 30 minutes during business hours.</p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 32 }}>
        <a href={WA_DEFAULT} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className="card" style={{ padding: 24, display: 'flex', alignItems: 'center', gap: 16, cursor: 'pointer' }}>
            <span style={{ fontSize: 32 }}>💬</span>
            <div>
              <h3 style={{ fontSize: 16, marginBottom: 4 }}>WhatsApp</h3>
              <p style={{ color: 'var(--text-2)', fontSize: 14 }}>+971 58 533 8786</p>
            </div>
          </div>
        </a>
        <a href="mailto:info@ebikedubai.ae" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className="card" style={{ padding: 24, display: 'flex', alignItems: 'center', gap: 16, cursor: 'pointer' }}>
            <span style={{ fontSize: 32 }}>📧</span>
            <div>
              <h3 style={{ fontSize: 16, marginBottom: 4 }}>Email</h3>
              <p style={{ color: 'var(--text-2)', fontSize: 14 }}>info@ebikedubai.ae</p>
            </div>
          </div>
        </a>
        <a href="tel:+971585338786" style={{ textDecoration: 'none', color: 'inherit' }}>
          <div className="card" style={{ padding: 24, display: 'flex', alignItems: 'center', gap: 16, cursor: 'pointer' }}>
            <span style={{ fontSize: 32 }}>📞</span>
            <div>
              <h3 style={{ fontSize: 16, marginBottom: 4 }}>Phone</h3>
              <p style={{ color: 'var(--text-2)', fontSize: 14 }}>+971 58 533 8786</p>
            </div>
          </div>
        </a>
        <div className="card" style={{ padding: 24, display: 'flex', alignItems: 'center', gap: 16 }}>
          <span style={{ fontSize: 32 }}>📍</span>
          <div>
            <h3 style={{ fontSize: 16, marginBottom: 4 }}>Location</h3>
            <p style={{ color: 'var(--text-2)', fontSize: 14 }}>Dubai, United Arab Emirates</p>
          </div>
        </div>
      </div>

      <div style={{ background: 'var(--dark-2)', border: '1px solid var(--dark-4)', borderRadius: 12, padding: 24, textAlign: 'center' }}>
        <h3 style={{ fontSize: 18, marginBottom: 8 }}>Business Hours</h3>
        <p style={{ color: 'var(--text-2)', fontSize: 14 }}>Saturday – Thursday: 9:00 AM – 9:00 PM</p>
        <p style={{ color: 'var(--text-2)', fontSize: 14 }}>Friday: 2:00 PM – 9:00 PM</p>
      </div>
    </div>
  );
}
